import React, { useEffect, useState } from 'react';

import { hasRoles, EDIT_FACILITIES_ROLES } from '../../../util/RoleUtil';

import { updateFacility } from '../../../services/FacilitiesService';

import { SaveButton } from '../../common/button/save-button/SaveButton';
import { Checkbox } from '../../common/checkbox/Checkbox';

import './FacilityEdit.css';

export const FacilityEdit = ({ context, showToaster, setSpinnerText, setIsModalOpen, clineaseFacility, retrieve }) => {
  const [facility, setFacility] = useState(false);
  const [subDistrict, setSubDistrict] = useState(false);
  const [district, setDistrict] = useState(false);
  const [province, setProvince] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (clineaseFacility) {
      setFacility(clineaseFacility.facility || '');
      setSubDistrict(clineaseFacility.subDistrict || '');
      setDistrict(clineaseFacility.district || '');
      setProvince(clineaseFacility.province || '');
      setIsActive(clineaseFacility.active || false);
    }
  }, [clineaseFacility]);

  const handleSaveChangesClick = () => {
    const facilityVO = {
      facilityExternalReference: clineaseFacility.externalReference,
      active: isActive,
    };

    handleUpdate(facilityVO);
  };

  const handleUpdate = async (facilityVO) => {
    const [data, error] = await updateFacility(context.username, facilityVO);
    if (data) {
      if (data.responseStatus === 'Success') {
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'Facility Updated',
        });
        setIsModalOpen(false);
        retrieve();
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const fieldsDisabled = !hasRoles(context, EDIT_FACILITIES_ROLES);

  return (
    <div className="tab-container facility-edit">
      <div className="input-container">
        <label className={'input-label'}>Facility:</label>
        <input className="text-input" type="text" value={facility} disabled={fieldsDisabled} />
      </div>
      <div className="input-container">
        <label className={'input-label'}>Sub-District:</label>
        <input className="text-input" type="text" value={subDistrict} disabled={fieldsDisabled} />
      </div>
      <div className="input-container">
        <label className={'input-label'}>District:</label>
        <input className="text-input" type="text" value={district} disabled={fieldsDisabled} />
      </div>
      <div className="input-container">
        <label className={'input-label'}>Province:</label>
        <input className="text-input" type="text" value={province} disabled={fieldsDisabled} />
      </div>
      <div className="input-container">
        <label className={'input-label'}>Active:</label>
        <Checkbox color={'#000000'} checked={isActive} onChange={setIsActive} disabled={fieldsDisabled} />
      </div>
      <div className="button-container">
        <SaveButton
          title={'Save Changes'}
          textColor={'#ffffff'}
          color={'#74a47f'}
          border={'1px solid #74a47f'}
          onClick={handleSaveChangesClick}
          disabled={fieldsDisabled}
        />
      </div>
    </div>
  );
};
